import { useMemo } from 'react'
import { StatusBadge } from './StatusBadge'

export function MutationErrorMessage(props: { mutation: { error?: unknown } }) {
	const errorMessage = useMemo(() => {
		const e = props.mutation.error
		if (e) {
			if (e instanceof Error) {
				return <StatusBadge status="rejected" label={e.message} />
			}
		}
		return null
	}, [props.mutation.error])
	return <>{errorMessage}</>
}
